import { defineMessages } from 'react-intl';

import type { AccountError } from '@/graphql/saleor/api';

import { type FormattedError } from './common';

export const errors = defineMessages({
  registeredYourAccount: {
    id: 'addWatch.yourAccount',
    defaultMessage: 'Watch is added successfully.',
  },
  registeredSameAccount: {
    id: 'addWatch.sameAccount',
    defaultMessage: 'This watch is already registered to your account.',
  },
  watchNotActivated: {
    id: 'addWatch.watchNotActivated',
    defaultMessage: 'This watch has not been activated yet.',
  },
  pleaseCheckAgain: {
    id: 'addWatch.pleaseCheckAgain',
    defaultMessage: 'Watch not found. Please try again.',
  },
  registeredToAnotherAccount: {
    id: 'addWatch.anotherAccount',
    defaultMessage: 'Watch already registered to another account.',
  },
});

export const getAddWatchErrorCodeMessage = (
  error: FormattedError<AccountError>,
) => {
  switch (error.code) {
    case 'INVALID':
      switch (error.field) {
        case '701':
          return errors.pleaseCheckAgain;
        case '810':
          return errors.registeredSameAccount;
        case '811':
          return errors.registeredToAnotherAccount;
        case '801':
          return errors.watchNotActivated;
        default:
          return errors.pleaseCheckAgain;
      }
    default:
      return errors.pleaseCheckAgain;
  }
};
